import { BooleanFilter } from "./boolean-filter";
import { IntegerFilter } from "./integer-filter";
import { ItemFilter } from "./item-filter";
import { StringFilter } from "./string-filter";

export class RouteFilter {
    public id?: IntegerFilter;
    public name?: StringFilter;
    public description?: StringFilter;
    public ecObjectCode?: StringFilter;
    public inforRouteCode?: StringFilter;
    public personnelGroups?: ItemFilter;
    public state?: StringFilter;
    public isActive?: BooleanFilter;
}
